import { render, staticRenderFns } from "./h5VideoLive.vue?vue&type=template&id=1d819cd6&scoped=true"
import script from "./h5VideoLive.vue?vue&type=script&lang=js"
export * from "./h5VideoLive.vue?vue&type=script&lang=js"
import style0 from "./h5VideoLive.vue?vue&type=style&index=0&id=1d819cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d819cd6",
  null
  
)

export default component.exports